import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {DEFAULT_PAGE_SIZES} from 'src/hooks/common-data-service/cached-table';

import {PaginationStripe} from '@pb/kit-component-pagination';

import {
    entitlementGrantChangeLogStateActions,
    entitlementGrantChangeLogStateSelector,
} from './slices/entitlement-grant-change-log-state.slice';

import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    totalCount: number,
};

export const EntitlementGrantChangeLogPagination = ({totalCount}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(entitlementGrantChangeLogStateSelector);

    const onChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        dispatch(entitlementGrantChangeLogStateActions.setPageSize(pageSize));
        dispatch(entitlementGrantChangeLogStateActions.setCurrentPage(1));
    }, [dispatch]);

    const onPaginationChange = useCallback((changedPagination: Pagination) => {
        dispatch(entitlementGrantChangeLogStateActions.setCurrentPage(changedPagination.currentPage));
    }, [dispatch]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={cacheKeys.pagination.pageSize}
            totalCount={totalCount}
            currentPage={cacheKeys.pagination.currentPage}
            onPaginationChange={onPaginationChange}
            onChangePaginationSize={onChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={DEFAULT_PAGE_SIZES}
        />
    );
};
